var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-offers-price"},[_c('app-content-title',{attrs:{"title":"Ценовая политика предложения","link-to":_vm.backRoute,"link-text":"Вернуться к предложению"}}),(!_vm.isLoading)?_c('div',{staticClass:"view-offers-price__price"},[_c('div',{staticClass:"view-offers-price__price-title row"},[_c('div',{staticClass:"col-md-12 col-6"},[_c('h2',{staticClass:"view-offers-price__price-heading"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"col-md-12 col-6 view-offers-price__row-select"},[_c('div',{staticClass:"view-offers-price__col-select"},[_c('app-select-control',{staticClass:"view-offers-price__price-select",attrs:{"title":"Выберите период","label":"label","track-by":"label","is-tooltip":"","tooltip":"Выберите период","options":_vm.$options.OPTIONS.DATE,"allowEmpty":false},model:{value:(_vm.dateOption),callback:function ($$v) {_vm.dateOption=$$v},expression:"dateOption"}})],1),_c('div',{staticClass:"view-offers-price__col-select"},[_c('app-select-control',{staticClass:"view-offers-price__price-select",attrs:{"title":"Выберите тип объема","label":"label","track-by":"label","is-tooltip":"","tooltip":"Выберите тип объемы","options":_vm.$options.OPTIONS.VOLUME,"allowEmpty":false},model:{value:(_vm.volumeOption),callback:function ($$v) {_vm.volumeOption=$$v},expression:"volumeOption"}})],1)])]),_c('app-chart-line',{staticClass:"view-offers-price__chart",attrs:{"chartData":{
        labels: _vm.labels,
        datasets: [
          {
            label: _vm.shortenedTitle,
            borderColor: '#02B55F',
            backgroundColor: 'transparent',
            cubicInterpolationMode: 'monotone',
            data: _vm.dataChart,
            pointBorderWidth: '4px',
            pointRadius: 4,
            pointBackgroundColor: '#02B55F',
          } ],
      },"options":{
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        aspectRatio: 1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: false,
                callback: function (value) { return this$1.$options.filters.price(value); },
              },
            } ],
        },
      }}})],1):_vm._e(),(_vm.isLoading)?_c('app-loader',{attrs:{"isCircle":"","isAbsolute":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }